export default {
  server: 'https://api.famicam.io',
  app: 'https://app.playbakvideo.com',
  debug: false,
};
